<template>
  <div class="">
    <div class="project-info"
         :class="{ 'diary': type === 'diary', 'work': type === 'work' }"
    >
      <div class="title"
      >
        {{ project.shortTitle ? project.shortTitle: project.title }}
      </div>
      <div class="user-info"
           v-if="user.name"
      >
        By <span class="name">{{ user.name }}</span>
      </div>
    </div>
    <div class="intro-info"
         :class="{ 'diary': type === 'diary', 'work': type === 'work' }"
    >
      <div class="item">
        <span class="label">出行天数</span>
        <div class="desc">{{ project.dayDesc }}</div>
      </div>
      <div class="item">
        <span class="label">目的地</span>
        <div class="desc">{{ project.destination }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProjectInfo',
    props: {
      project: {
        type: Object,
        required: true,
      },
      user: {
        type: Object,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .project-info {
    &.diary {
      padding-bottom: @size-small;
      margin-bottom: @size-extra-medium;
      border-bottom: @border-base;
    }
    &.work {
      margin-bottom: @size-medium;
      padding: 0 @size-base;
    }
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    font-size: @font-size-extra-large;
    color: @color-text-base;
    font-weight: @font-weight-bold;
    .title {
      font-size: @font-size-extra-large;
    }
    .user-info {
      font-size: @font-size-base;
      color: @color-text-lighter;
      font-weight: @font-weight-primary;
      .name {
        margin-left: @size-extra-small;
      }
    }
  }

  .intro-info {
    &.diary {
      margin-bottom: @size-medium;
    }
    &.work {
      padding-left: @size-base;
      padding-bottom: @size-medium;
      position: relative;
      &:after {
        position: absolute;
        left: @size-base;
        bottom: 0;
        content: '';
        width: 690px;
        height: 2px;
        background: #eee;

      }
    }
    display: flex;
    align-items: center;
    .item {
      width: 50%;
      padding-left: 2px;
      display: flex;
      align-items: center;
    }
    .label {
      margin-right: @size-small;
      padding: 6px 12px;
      box-sizing: border-box;
      font-size: @font-size-small;
      line-height: 1;
      color: @color-text-light;
      border-radius: @border-radius-extra-large;
      border: @border-width-base @border-style-base #aaa;
    }
    .desc {
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      color: @color-text-base;
      line-height: 1;
    }
  }
</style>
